import { Flex, Tooltip } from 'antd';
import { Maybe, Tag } from '../graphql';

export default function Tags({
  tags,
}: {
  tags: Tag[] | undefined | Maybe<Array<Tag>>;
}) {
  if (!tags) return;
  return (
    <Flex gap={6} align={'center'}>
      {tags.map((tag) => (
        <Tooltip title={tag.title}>
          <img
            src={tag.image}
            alt={''}
            style={{
              height: 18,
              width: 18,
              objectFit: 'cover',
              objectPosition: 'center',
            }}
          />
        </Tooltip>
      ))}
    </Flex>
  );
}
